module.exports = __webpack_public_path__ + "445ecd8407bb54a2477891f4f9f6e3f1.png";


//////////////////
// WEBPACK FOOTER
// ./res/images/logo/pt/google_store.png
// module id = 878
// module chunks = 0